export const bars = [25, 50, 75, 100]; // Проценты высоты столбцов

export const signalLevels = [
    { min: 1, max: 9, level: 1, color: 'red' },
    { min: 10, max: 14, level: 2, color: '#f0b410' },
    { min: 15, max: 25, level: 3, color: '#f0b410' },
    { min: 26, max: 32, level: 4, color: '#0ca32a' }
  ];